import { securedAxiosAPI } from 'utils/axios';
import { store } from '../../store';
import { multipartHeaderConfig } from './user';
// APIS

// Secured Routes

const securedRoute = {
    costingCards: 'costing-analysis/costing-template',
    standardCostings: 'costing-analysis/standard-costing',
    customerSpecificCosting: 'costing-analysis/customer-costing?customer_id=##CUSTOMER_ID##',
    updateCustomerSpecificCost: 'costing-analysis/customer-analysis',
    updateCostingCardAsStandard: 'costing-analysis/costing-template-status',
    cardCostingDetails: 'costing-analysis/costing-template-details?template_id=##TEMPLATE_ID##',
    updateTemplateCosting: 'costing-analysis/costing-bulk'
};

const securedInvoiceRoute = {
    invoiceCertifcates:
        'invoice/certificates/##CUSTOMER_ID##/?page_number=##PAGE_NUMBER##&page_size=##PAGE_SIZE##&from_date=##FROM_DATE##&to_date=##TO_DATE##',
    invoice: 'invoice/?page_number=##PAGE_NUMBER##&page_size=##PAGE_SIZE##&logged_in_portal=##PORTAL##&customer_id=##CUSTOMER_ID##',
    invoiceById: 'invoice/##ID##',
    invoiceStatusFinalized: 'invoice/##ID##/##USER_ID##/finalized',
    invoiceVatUpdate: 'invoice/##ID##/vat-costing',
    invoiceList: 'invoice/search',
    invoiceFormat: 'invoice/generateInvoiceFormat',
    invoiceDownloadExcel: 'invoice/download-invoice-excelfile'
};

export const getcostingCards = async () => {
    const res = await securedAxiosAPI.get(securedRoute?.costingCards);
    return res.data;
};
// Add New Template
export const addNewcostingCards = async (data) => {
    const res = await securedAxiosAPI.post(securedRoute?.costingCards, data);
    return res.data;
};

export const getStandardCostings = async () => {
    const res = await securedAxiosAPI.get(securedRoute?.standardCostings);
    return res.data;
};
export const getCustomerSpecificCostings = async (customerId) => {
    const res = await securedAxiosAPI.get(securedRoute?.customerSpecificCosting.replaceAll('##CUSTOMER_ID##', customerId));
    return res.data;
};

export const updateSpecificCustomerCostings = async (data) => {
    const res = await securedAxiosAPI.post(securedRoute?.updateCustomerSpecificCost, data);
    return res.data;
};
// updateCostingCardAsStandard
export const updateCostingCardAsStandard = async (data) => {
    const res = await securedAxiosAPI.put(securedRoute?.updateCostingCardAsStandard, data);
    return res.data;
};
// card Costing Details
export const cardCostingDetails = async (id) => {
    const res = await securedAxiosAPI.get(securedRoute?.cardCostingDetails.replaceAll('##TEMPLATE_ID##', id));
    return res.data;
};
//
//
//
// Invoicing
export const getCertificatesList = async ({ customerId, fromDate, toDate }) => {
    const { getState } = store;
    const { pageCertificate, rowsPerPageCertificate } = getState().costingInvoicing;
    const res = await securedAxiosAPI.get(
        securedInvoiceRoute?.invoiceCertifcates
            .replaceAll('##CUSTOMER_ID##', customerId)
            .replaceAll('##PAGE_NUMBER##', pageCertificate + 1)
            .replaceAll('##PAGE_SIZE##', rowsPerPageCertificate)
            .replaceAll('##FROM_DATE##', fromDate)
            .replaceAll('##TO_DATE##', toDate)
    );
    return res.data;
};

export const addInvoice = async (formdata) => {
    const res = await securedAxiosAPI.post(securedInvoiceRoute?.invoice, formdata, multipartHeaderConfig);
    return res.data;
};
//
export const getInvoiceList = async () => {
    const { getState } = store;

    const { pageInvoice: page, rowsPerPageInvoice: rowsPerPage } = getState().costingInvoicing;

    const {
        loggedInUser: { customerId },
        loggedInPortal
    } = getState().user;

    const res = await securedAxiosAPI.get(
        securedInvoiceRoute?.invoice
            .replaceAll('##PAGE_NUMBER##', page + 1)
            .replaceAll('##PAGE_SIZE##', rowsPerPage)
            .replaceAll('##PORTAL##', loggedInPortal)
            .replaceAll('##CUSTOMER_ID##', customerId)
    );
    return res.data;
};

export const getInvoiceListByColumnFilter = async (payload) => {
    const { columnFilterName } = payload;
    const { getState } = store;

    const { [columnFilterName]: columnFilter, pageInvoice: page, rowsPerPageInvoice: rowsPerPage } = getState().costingInvoicing;

    const { customerId } = getState().user.loggedInUser;
    const filters = Object.keys(columnFilter);
    const data = {
        invoiceId: [],
        customers: [],
        issuedDate: [],
        status: []
    };
    filters.forEach((filterName) => {
        columnFilter[filterName].appliedList.forEach((item) => {
            if (filterName === 'issuedDate') {
                data[filterName].push(item);
            } else {
                data[filterName].push(item.id);
            }
        });
    });
    const finalData = {
        invoiceIds: data?.invoiceId,
        filterCustomerIds: data?.customers,
        issueDates: data?.issuedDate,
        status: data?.status
    };
    const res = await securedAxiosAPI.post(`${securedInvoiceRoute?.invoiceList}/`, {
        ...finalData,
        page: page + 1,
        rowsPerPage,
        customerId
    });

    return res.data;
};
// ID
export const getInvoiceDetailsById = async (id) => {
    const res = await securedAxiosAPI.get(securedInvoiceRoute?.invoiceById.replaceAll('##ID##', id));

    return res.data;
};

export const downloadInvoiceExcelFile = async (payload) => {
    const { getState } = store;
    const { customerId } = getState().user.loggedInUser;
    const response = await securedAxiosAPI.post(
        securedInvoiceRoute?.invoiceDownloadExcel,
        {
            customerId: payload?.customerId || customerId,
            invoiceIds: payload?.invoiceIds || [],
            filterCustomerIds: payload?.filterCustomerIds || [],
            issueDates: payload?.issueDates || [],
            status: payload?.status || []
        },
        {
            responseType: 'blob'
        }
    );

    const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'invoiced_samples.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
// invoice Status Finalized

export const setInvoiceStatusToFinalise = async ({ id, userID, formData }) => {
    const res = await securedAxiosAPI.post(
        securedInvoiceRoute?.invoiceStatusFinalized.replaceAll('##ID##', id).replaceAll('##USER_ID##', userID),
        formData,
        multipartHeaderConfig
    );
    return res.data;
};

export const updateInvoiceCertificates = async ({ id, ...data }) => {
    const res = await securedAxiosAPI.put(securedInvoiceRoute?.invoiceById.replaceAll('##ID##', id), data);
    return res.data;
};
//
export const finalSaveInvoiceCertificates = async ({ id, ...data }) => {
    const res = await securedAxiosAPI.patch(securedInvoiceRoute?.invoiceVatUpdate.replaceAll('##ID##', id), data);
    return res.data;
};

export const updateTemplateCosting = async (data) => {
    const res = await securedAxiosAPI.post(securedRoute?.updateTemplateCosting, data);
    return res.data;
};

export const getInvoiceSeriesFormat = async () => {
    const res = await securedAxiosAPI.get(securedInvoiceRoute?.invoiceFormat);
    return res.data;
};
